import React from 'react';
import styled from 'styled-components';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import BusinessListUnitItem from '../BusinessListUnitItem/BusinessListUnitItem';
import BusinessGroupListItem from '../BusinessGroupListItem/BusinessGroupListItem';

const StyledBusinessDisplayUnitItem = styled.div``;

interface BusinessDisplayUnitItemProps {
    businessDisplayUnit: BusinessDisplayUnit;
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}
const BusinessDisplayUnitItem = ({
    businessDisplayUnit,
    onSelect,
}: BusinessDisplayUnitItemProps) => {
    return (
        <StyledBusinessDisplayUnitItem>
            {businessDisplayUnit.isBusiness ? (
                <BusinessListUnitItem
                    businessDisplayUnit={businessDisplayUnit}
                    onSelect={onSelect}
                />
            ) : (
                <BusinessGroupListItem businessGroup={businessDisplayUnit} onSelect={onSelect} />
            )}
        </StyledBusinessDisplayUnitItem>
    );
};

export default BusinessDisplayUnitItem;
